import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetSentNotificationsQuery } from '../../../store/api/adminApi';
import PageLoader from '../../../components/PageLoader';
import Pagination from '../../../components/Pagination';

const Notifications: React.FC = () => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);

  const { data, isLoading, error } = useGetSentNotificationsQuery({ page });

  const notifications = data?.data?.data || [];
  const meta = data?.data;

  if (isLoading) {
    return <PageLoader />;
  }

  if (error) {
    return <div className="alert alert-danger m-5">Error loading notifications</div>;
  }

  return (
    <div className="app-main flex-column flex-row-fluid" id="kt_app_main">
      <div className="d-flex flex-column flex-column-fluid">
        <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
          <div id="kt_app_toolbar_container" className="app-container container-xxl d-flex flex-stack">
            <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
              <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Sent Notifications</h1>
              <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
                <li className="breadcrumb-item text-muted">
                  <span className="text-muted text-hover-primary" onClick={() => navigate('/admin/dashboard')} style={{ cursor: 'pointer' }}>Home</span>
                </li>
                <li className="breadcrumb-item">
                  <span className="bullet bg-gray-400 w-5px h-2px"></span>
                </li>
                <li className="breadcrumb-item text-muted">Sent Notifications</li>
              </ul>
            </div>
            <div className="d-flex align-items-center gap-2 gap-lg-3">
              <button 
                className="btn btn-sm fw-bold btn-base"
                onClick={() => navigate('/admin/notifications/send')}
              >
                Send New Notification
              </button>
            </div>
          </div>
        </div>

        <div id="kt_app_content" className="app-content flex-column-fluid">
          <div id="kt_app_content_container" className="app-container container-xxl">
            <div className="card card-flush">
              <div className="card-body pt-5">
                <div className="table-responsive">
                  <table className="table align-middle table-row-dashed fs-6 gy-5">
                    <thead>
                      <tr className="text-start text-gray-400 fw-bold fs-7 text-uppercase gs-0">
                        <th className="min-w-150px">Title</th>
                        <th className="min-w-250px">Body</th>
                        <th className="min-w-100px">Target</th>
                        <th className="min-w-100px">Method</th>
                        <th className="min-w-100px">Users</th>
                        <th className="min-w-150px">Sent At</th>
                      </tr>
                    </thead>
                    <tbody className="fw-semibold text-gray-600">
                      {notifications.length > 0 ? (
                        notifications.map((notification: any) => (
                          <tr key={notification.id}>
                            <td>{notification.title}</td>
                            <td>
                              <div className="text-truncate" style={{ maxWidth: '300px' }}>
                                {notification.body}
                              </div>
                            </td>
                            <td>
                              <span className="badge badge-light-primary">{notification.target_users}</span>
                            </td>
                            <td>
                              <span className="badge badge-light-info">{notification.send_method}</span>
                            </td>
                            <td>{notification.total_users}</td>
                            <td>{notification.sent_at ? new Date(notification.sent_at).toLocaleString() : 'Pending'}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={6} className="text-center">No notifications found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                {meta && (
                  <Pagination 
                    currentPage={page} 
                    lastPage={meta.last_page} 
                    total={meta.total}
                    perPage={meta.per_page}
                    onPageChange={setPage} 
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notifications;
